import { combineReducers } from 'redux';
import * as types from './constants';

const notifications = (state = [], action) => {
  switch (action.type) {
    case types.NOTIFICATION_ADD:
      return [
        action.entity,
        ...state
      ];
    case types.NOTIFICATION_REMOVE:
      return state.filter(notification => notification.id !== action.id);
    default:
      return state;
  }
};

const reducer = combineReducers({
  notifications
});

export default reducer;
